export default function calculateInputWidth(options) {
  var hintSizerRef = options.hintSizerRef,
      inputSizerRef = options.inputSizerRef,
      inputType = options.inputType,
      inputValue = options.inputValue,
      _options$minWidth = options.minWidth,
      minWidth = _options$minWidth === void 0 ? 0 : _options$minWidth;
  var width;

  if (inputSizerRef.current != null) {
    if (hintSizerRef.current != null && (inputValue == null || !inputValue.length)) {
      width = Math.max(inputSizerRef.current.scrollWidth, hintSizerRef.current.scrollWidth);
    } else {
      width = inputSizerRef.current.scrollWidth;
    }
  } else {
    width = 0;
  } // Add 16 pixels to allow for the stepper UI for numeric inputs


  if (inputType === 'number') {
    width += 16;
  }

  width += 2;

  if (width < minWidth) {
    width = minWidth;
  }

  return width;
}